<template>
  <div>
    <fieldset class="border p-3">
      <legend>
        <small style="font-size:15px; font-weight: bold">new Transaction</small>
      </legend>
      <div>
        <form @submit.prevent="newTransaction()">
          <div class="row">
            <div class="col-md-6">
              <div class="accounttypesLoader">
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                <i class="fa fa-spinner fa-spin" style="font-size:24px; color: blue"></i>loading...
              </div>
              <div class="form-group">
                <label>Petty cash expense</label>
                <select class="form-control accounttype_id input-rounded f-s-14" required>
                  <option value>Select a/c expense</option>
                  <option
                    v-for="accounttype in systemPettyaccounts"
                    :value="accounttype.id"
                    :key="accounttype.id"
                  >{{ accounttype.pettyaccounts_name }}</option>
                </select>
              </div>
              <div class="form-group">
                <label>Payee name</label>
                <input
                  type="text"
                  class="form-control payee_name input-rounded f-s-14"
                  placeholder="payee name"
                  required
                />
              </div>
              <div class="form-group">
                <label>Payee amount</label>
                <input
                  type="number"
                  class="form-control payee_amount input-rounded f-s-14"
                  placeholder="payee amount"
                  required
                />
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>Account</label>
                <select name="account_id" class="form-control pettyaccount_id input-rounded f-s-14">
                  <option
                    v-for="accounttype in systemAccounttypes"
                    :value="accounttype.id"
                    :key="accounttype.id"
                  >{{ accounttype.account_name }}</option>
                </select>
              </div>
              <div class="form-group">
                <label>Payee description</label>
                <input
                  type="text"
                  class="form-control payee_description input-rounded f-s-14"
                  placeholder="payee description"
                  required
                />
              </div>
            </div>
          </div>
          <button
            type="submit"
            class="btn btn-primary btn-flat creatingDailytransaction btn-rounded"
          >
            <i class="fa fa-plus"></i> Add transaction
          </button>
          <button
            type="button"
            class="btn btn-primary btn-flat creatingDailytransactionLoader btn-rounded"
          >
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            <i class="fa fa-spinner fa-spin" style="font-size:24px"></i> please wait...
          </button>
        </form>
      </div>
    </fieldset>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
export default {
  created() {
    this.loadAccounttypes();
    this.loadPettyaccounts();
  },
  computed: {
    ...mapGetters(["systemAccounttypes", "systemPettyaccounts"])
  },
  methods: {
    ...mapActions(["loadAccounttypes", "newTransaction", "loadPettyaccounts"])
  }
};
</script>
<style scoped>
.creatingDailytransactionLoader {
  display: none;
}
</style>


// WEBPACK FOOTER //
// src/dailytransactions/dailytransaction.vue